module.exports = __webpack_public_path__ + "static/low-36e8c832c2e273dd8ab5e5375aabe016.png";